// @flow
import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "../reducers/rootReducer";
import { loadingBarMiddleware } from "react-redux-loading-bar";
import handleRejectedPromiseMiddleware from "./handleRejectedPromiseMiddleware";
//import logger from 'redux-logger';
// import thunk from 'redux-thunk';
//import promiseMiddleware  from 'redux-promise';
//import promiseMiddleware from "redux-promise-middleware";
import InitialState from "../reducers/initialState";
import { Cart } from "../flow/types";
import thunk from 'redux-thunk';
import promise from 'redux-promise-middleware';

export default function configureStore() {

    let storageSupported = false;
    try { storageSupported = (window.localStorage && true) } catch (e) { }
    if (!storageSupported) {
        Object.defineProperty(window, 'localStorage', {
            value: {
                _data: {},
                setItem: function (id, val) { return this._data[id] = String(val); },
                getItem: function (id) { return this._data.hasOwnProperty(id) ? this._data[id] : undefined; },
                removeItem: function (id) { return delete this._data[id]; },
                clear: function () { return this._data = {}; }
            }
        });
        Object.defineProperty(window, 'sessionStorage', {
            value: {
                _data: {},
                setItem: function (id, val) { return this._data[id] = String(val); },
                getItem: function (id) { return this._data.hasOwnProperty(id) ? this._data[id] : undefined; },
                removeItem: function (id) { return delete this._data[id]; },
                clear: function () { return this._data = {}; }
            }
        });
    }

  const persistedState = localStorage.getItem("shopState");
  const preloadState = persistedState
    ? JSON.parse(persistedState)
    : InitialState;

    
    //Disable reloading tokens as we have problems with expired tokens
    if (preloadState.user) {
        //preloadState.user = new User();
        //preloadState.user.accessToken = "";
        //preloadState.user.isAuthenticated = false;
        preloadState.user.isCustomerExists = undefined;
        preloadState.user.isAccountCreated = undefined;
        preloadState.user.isProfileSaved = undefined;
    }

    if (!preloadState.cart || !preloadState.cart.lines) {
        preloadState.cart = new Cart(0, 'Default', true, preloadState.user ? preloadState.user.userId : null);
    }
    // Reload saved user locale, or fall back to supplier default
    preloadState.locale = preloadState.user && preloadState.user.locale ? preloadState.user.locale : (preloadState.settings && preloadState.settings.locale ? preloadState.settings.locale : null);

    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const store = createStore(
    rootReducer,
    preloadState,
    composeEnhancers(
        applyMiddleware(
        thunk,
        handleRejectedPromiseMiddleware(),
       // promiseMiddleware(),
            promise,
        loadingBarMiddleware(),
        //logger
      )
    )
  );
  return store;

}
